export function headerScript() {
  const header = document.querySelector('.l-header');
  const menuButton = document.getElementById('menu-button');
  const overlay = document.querySelector('.menu-overlay');
  const menuLinks = document.querySelectorAll('.l-header a');

  // メニューボタンをクリックしてメニューを開閉する
  menuButton.addEventListener('click', () => {
      header.classList.toggle('menu-open');
      menuButton.classList.toggle('is-active');
      overlay.classList.toggle('is-visible');
  });

  // メニューの外をクリックしたらメニューを閉じる
  overlay.addEventListener('click', () => {
      header.classList.remove('menu-open');
      menuButton.classList.remove('is-active');
      overlay.classList.remove('is-visible');
  });

  // メニュー内のリンクをクリックしたらメニューを閉じる
  menuLinks.forEach(link => {
      link.addEventListener('click', () => {
          header.classList.remove('menu-open');
          menuButton.classList.remove('is-active');
          overlay.classList.remove('is-visible');
      });
  });

  // デバイスのサイズに応じてイベントを追加または削除
  function adjustMenuEvents() {
    const navItems = document.querySelectorAll('.l-header__nav-item');

    if (window.innerWidth >= 1280) { // 例えば1280px以上でホバーイベントを適用
        navItems.forEach(item => {
            item.removeEventListener('click', toggleDropdown); // クリックイベントを削除
        });
    } else {
        navItems.forEach(item => {
            item.addEventListener('click', toggleDropdown); // クリックイベントを追加
        });
    }
}

  function openDropdown() {
    const dropdownMenu = this.querySelector('.l-header__dropdown-menu');
    if (dropdownMenu) { // dropdownMenuが存在するか確認
        dropdownMenu.style.maxHeight = '300px';
    } else {
        console.error('Dropdown menu not found in this context:', this);
    }
}

function closeDropdown() {
    const dropdownMenu = this.querySelector('.l-header__dropdown-menu');
    if (dropdownMenu) { // dropdownMenuが存在するか確認
        dropdownMenu.style.maxHeight = '0';
    } else {
        console.error('Dropdown menu not found in this context:', this);
    }
}

function toggleDropdown() {
    const dropdownMenu = this.querySelector('.l-header__dropdown-menu');
    if (dropdownMenu) {
        if (dropdownMenu.style.maxHeight === '300px') {
            dropdownMenu.style.maxHeight = '0';
        } else {
            dropdownMenu.style.maxHeight = '300px';
        }
    } else {
        console.error('Dropdown menu not found in this context:', this);
    }
}


  // ウィンドウサイズの変更時にイベントを再調整
  window.addEventListener('resize', adjustMenuEvents);

  // 初回ロード時に適切なイベントを設定
  adjustMenuEvents();
}
